module.exports = __webpack_public_path__ + "static/media/no_image.17ca53c0.svg";